
import { AuthKeys } from '@/i18n/types';

export const auth: Record<AuthKeys, string> = {
  email: 'Correo electrónico',
  password: 'Contraseña',
  name: 'Nombre',
  confirmPassword: 'Confirmar contraseña',
  namePlaceholder: 'Ingresa tu nombre',
  signIn: 'Iniciar Sesión',
  signUp: 'Regístrate',
  signOut: 'Cerrar Sesión',
  forgotPassword: '¿Olvidaste tu contraseña?',
  resetPassword: 'Restablecer Contraseña',
  changePassword: 'Cambiar Contraseña',
  creatingAccount: 'Creando cuenta...',
  authError: 'Error de autenticación. Por favor, inicie sesión nuevamente.',
  alreadyHaveAccount: '¿Ya tienes una cuenta?',
  checkEmailConfirmation: 'Por favor revisa tu correo para confirmar tu cuenta',
  createAccountDesc: 'Crea una cuenta para empezar a gestionar tu vida',
  passwordMismatch: 'Las contraseñas no coinciden',
  emailAlreadyRegistered: 'Correo electrónico ya registrado',
  login: 'Iniciar sesión',
  loginButton: 'Iniciar sesión',
  signupButton: 'Registrarse',
  invalidEmail: 'Correo electrónico inválido',
  requiredField: 'Este campo es obligatorio',
  enterNewPassword: 'Ingresa tu nueva contraseña',
  newPassword: 'Nueva contraseña',
  confirmNewPassword: 'Confirmar nueva contraseña',
  confirmYourNewPassword: 'Confirma tu nueva contraseña',
  updatePassword: 'Actualizar contraseña',
  enterEmailResetPassword: 'Ingresa tu correo electrónico para restablecer tu contraseña',
  enterEmail: 'Ingresa tu correo electrónico',
  enterPassword: 'Ingresa tu contraseña',
  confirmYourPassword: 'Confirma tu contraseña',
  backToLogin: 'Volver al inicio de sesión',
  emailSent: 'Correo enviado',
  emailSentDescription: 'Revisa tu bandeja de entrada para restablecer tu contraseña',
  emailSentToAddress: 'Hemos enviado un enlace de restablecimiento a {email}',
  checkInboxDescription: 'Revisa tu bandeja de entrada y haz clic en el enlace para restablecer tu contraseña',
  checkSpamDescription: '¿No ves el correo? Revisa tu carpeta de spam o inténtalo de nuevo',
  sendAgain: 'Enviar de nuevo',
  sending: 'Enviando',
  sendResetLink: 'Enviar enlace de restablecimiento',
  invalidEmailDescription: 'Por favor ingresa un correo electrónico válido',
  rateLimitError: 'Demasiados intentos',
  rateLimitDescription: 'Has hecho demasiados intentos. Espera un momento antes de intentar de nuevo',
  emailNotFoundDescription: 'No se encontró una cuenta con este correo electrónico',
  resetEmailError: 'No se pudo enviar el correo de restablecimiento',
  unexpectedError: 'Ocurrió un error inesperado. Inténtalo de nuevo',
};
